import axiosInstanceNew from "../lib/axiosinstanceNew";

const ParentandtutoractiveModal = class {

  
    async Active(id,data =[]){
        return(
            await axiosInstanceNew.put(`user/update/${id}`,data)
        )
    }
  
}
export default new ParentandtutoractiveModal();